import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { TillageCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface TillageCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const TillageCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: TillageCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="tillage"
      onSaveSuccess={onSaveSuccess}
    >
      <TillageCellDisplay value={value} />
    </TraitCellContainer>
  )
}
